<div
  *ngFor="let prenotazione of carrello; let idx = index; let last = last"
  class="riga"
>
  <div class="row lis-relative flex-md-row flex-column">
    <a
      (click)="rimuoviDalCarrello(prenotazione.idcarrello)"
      class="puntatore d-flex text-right cancella"
      *ngIf="mostraCancella(idx)"
    >
      <span
        class="material-symbols-outlined"
        [matTooltip]="'carrello__item.elimina' | translate"
        matTooltipPosition="left"
      >
        highlight_off
      </span>
    </a>
    <div class="col-12 col-md-12">
      <div class="mt-2 d-flex flex-wrap grid-cg-05">
        {{ "base.descrizione_esperienza" | translate }}
        <span class="lis-font-weight-600">
          {{ prenotazione.tipovisita }}
        </span>
      </div>
      <div
        class="mb-2 d-flex flex-wrap grid-cg-05"
        *ngIf="!visitaHasPernottamento(prenotazione)"
      >
        <div>
          {{ "base.data_esperienza" | translate }}
        </div>
        <div class="lis-font-weight-600">
          {{ prenotazione.dataora | localizedDate }} -
          {{ prenotazione.dataora | localizedDate : "shortTime" }}
        </div>
      </div>
      <div
        class="d-flex flex-wrap grid-cg-05"
        *ngIf="visitaHasPernottamento(prenotazione)"
      >
        <label>
          {{ "prenotazioni.checkin_pernottamento" | translate }}
        </label>
        <div class="lis-font-weight-600">
          {{
            prenotazione.check_in_visita
              ? (prenotazione.dataora | localizedDate) +
                " " +
                prenotazione.check_in_visita
              : ("prenotazioni.dadefinire" | translate)
          }}
        </div>
      </div>
      <div
        class="mb-2 d-flex flex-wrap grid-cg-05"
        *ngIf="visitaHasPernottamento(prenotazione)"
      >
        <label>
          {{ "prenotazioni.datavisitapernottamento" | translate }}
        </label>
        <div class="lis-font-weight-600">
          {{
            getDataSvolgimento(prenotazione) &&
            getDataSvolgimento(prenotazione)["translation"]
              ? (getDataSvolgimento(prenotazione)["data"] | translate)
              : (getDataSvolgimento(prenotazione)["data"] | localizedDate)
          }}
          <br *ngIf="!getDataSvolgimento(prenotazione)['translation']" />
          <small
            *ngIf="!getDataSvolgimento(prenotazione)['translation']"
            class="stessa__data"
          >
            {{ "prenotazioni.orariocomunicato" | translate }}
          </small>
        </div>
      </div>
      <div class="mt-2">
        {{ "base.lingua_selezionata" | translate }}
        <span class="lis-font-weight-600 ml-2">
          <span class="d-flex align-center">
            {{ prenotazione.linguaSelezionata | lowercase | translate }}
            <img
              src="assets/img/flags/flag-{{
                prenotazione.linguaSelezionata | lowercase
              }}.png"
              alt="Flag {{
                prenotazione.linguaSelezionata | lowercase | translate
              }}"
              class="info__box__lang__chip__flag"
            />
          </span>
        </span>
      </div>
      <div [innerHTML]="'carrello__item.warn_lingua' | translate"></div>
      <div class="mt-2">
        <div class="posti">
          <span class="mr-2">
            {{ "step1.intero" | translate }}
          </span>
          <span class="lis-font-weight-600">
            {{ prenotazione.nadulti }}
          </span>
        </div>
        <div class="posti" *ngIf="prenotazione.nadulti_solovisita > 0">
          <span class="mr-2">
            {{ "step1.solovisita" | translate }}
          </span>
          <span class="lis-font-weight-600">
            {{ prenotazione.nadulti_solovisita }}
          </span>
        </div>
        <div class="posti" *ngIf="prenotazione.nridotti > 0">
          <span class="mr-2">
            {{ "step1.ridotto" | translate }}
          </span>
          <span class="lis-font-weight-600">
            {{ prenotazione.nridotti }}
          </span>
        </div>
        <div class="posti" *ngIf="prenotazione.nminori > 0">
          <span class="mr-2">
            {{ "step1.minori" | translate }}
          </span>
          <span class="lis-font-weight-600">
            {{ prenotazione.nminori }}
          </span>
        </div>
      </div>
      <div
        class="mt-5"
        *ngIf="
          (prenotazione.opzioniVisita &&
            prenotazione.opzioniVisita.length > 0) ||
          (prenotazione.giteVisita && prenotazione.giteVisita.length > 0)
        "
      >
        <small class="lis-font-weight-600">
          {{ "base.extra_aggiunti" | translate }}
        </small>
      </div>
      <div
        class="opzioni"
        *ngIf="
          prenotazione.opzioniVisita && prenotazione.opzioniVisita.length > 0
        "
      >
        <div class="row" *ngFor="let opzione of prenotazione.opzioniVisita">
          <div class="col-1 col-md-1">+</div>
          <div class="col-8 col-md-8">
            {{ opzione.titolo }}
          </div>
          <div class="col-3 col-md-2">(x{{ opzione.qta }})</div>
        </div>
      </div>
      <div
        class="gite"
        *ngIf="prenotazione.giteVisita && prenotazione.giteVisita.length > 0"
      >
        <div class="row" *ngFor="let gita of prenotazione.giteVisita">
          <div class="col-1 col-md-1">+</div>
          <div class="col-8 col-md-8">
            {{ gita.titolo }}
          </div>
          <div class="col-3 col-md-2">(x{{ gita.qta }})</div>
        </div>
      </div>
      <p
        class="mb-0 mt-3"
        *ngIf="prenotazione.promo != '' && prenotazione.promo != null"
      >
        <small class="lis-font-weight-600">
          {{ "base.promo" | translate }}
        </small>
        <span class="promo ml-2">{{ prenotazione.promo }}</span>
      </p>
    </div>
    <div
      class="col-12 col-md-12 d-flex align-items-end justify-content-end mt-3 flex-wrap"
    >
      <hr class="w-100" />
      <div class="d-flex align-items-end justify-content-end w-100">
        <div class="text-right">
          <div>
            {{ "step1.totale" | translate }}
            <span class="lis-font-weight-500 lis-dark lis-font-weight-600"
              >€ {{ totaleRiga(prenotazione) }}</span
            >
          </div>
          <div *ngIf="checkSC(prenotazione)">
            <span
              class="descriSupplemento"
              [matTooltip]="'carrello.pagaCantinaSCNoteTooltip' | translate"
              >{{
                "carrello.supplemento"
                  | translate : { value: getSupplementoTotale(prenotazione) }
              }}
              <i class="fas fa-info"></i
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngFor="let riga of carrelloVini; let last = last" class="riga">
  <div class="row lis-relative flex-md-row flex-column">
    <div class="flex__pannelli">
      <div class="col-12" *ngIf="riga.attivoVoucherCarrello">
        <app-pannello-info
          [icon]="''"
          [title]="msgAttenzione(riga).title"
          [content]="msgAttenzione(riga).msg"
          [type]="msgAttenzione(riga).color"
          [values]="msgAttenzione(riga).values"
        ></app-pannello-info>
      </div>

      <div
        class="col-12"
        *ngIf="!isMinimiVinoOk(riga) || !isMultipliVinoOK(riga)"
      >
        <div class="errore__container">
          <div *ngIf="!isMinimiVinoOk(riga)">
            <span
              [innerHTML]="
                'carrello__item.pezziMin' | translate : { min: riga.pezziMin }
              "
            >
            </span>
            <span
              class="counter"
              [ngClass]="!isMinimiVinoOk(riga) ? 'ko' : 'ok'"
            >
              ({{ riga.qta }} {{ "carrello__item.su" | translate }}
              {{ riga.pezziMin }})
            </span>
          </div>
          <div *ngIf="!isMultipliVinoOK(riga)">
            <span
              [innerHTML]="
                'carrello__item.pezziMultipli'
                  | translate : { multiplo: riga.multipli }
              "
            >
            </span>
            <span class="counter ko">
              {{ getExMultipli(riga.multipli) }}
            </span>
          </div>
        </div>
      </div>

      <div
        class="col-12"
        *ngIf="riga.sconto == 0 && !riga.scontoValido && !riga.scontoScaduto"
      >
        <app-pannello-info
          [icon]="''"
          [title]="msgSconto(riga).title"
          [content]="msgSconto(riga).content"
          [type]="'PRIMARY'"
          [values]="msgSconto(riga).values"
        ></app-pannello-info>
      </div>
    </div>

    <div
      *ngIf="
        riga.pezziMin > riga.qta ||
        !isMultipliVinoOK(riga) ||
        riga.attivoVoucherCarrello ||
        (riga.sconto == 0 && !riga.scontoValido && !riga.scontoScaduto)
      "
    >
      <hr />
    </div>

    <div class="col-12 col-md-12">
      <div class="vino-item" *ngFor="let vino of riga.vini; let last = last">
        <h6 class="lis-font-weight-500 mb-2 vino-comprato">
          <span
            class="material-symbols-outlined mr-2 puntatore elimina-vino"
            (click)="rimuoviDalCarrelloVinoSingolo(vino.idcarrello_vini)"
            [matTooltip]="
              'carrello__item.eliminavino' | translate : { value: vino.nome }
            "
            matTooltipPosition="left"
            >highlight_off</span
          >
          <div class="vino">
            ({{ vino.qta }}x)
            {{ vino.nome }}
            <span *ngIf="vino.annata">&nbsp;({{ vino.annata }})</span>
          </div>
        </h6>

        <div>
          <p *ngIf="vino.promo != '' && vino.promo != null">
            <small class="lis-font-weight-600">
              {{ "base.promo" | translate }}
            </small>
            <span class="promo ml-2">{{ vino.promo }}</span>
          </p>
          <small> € {{ vino.totale }} </small>
        </div>

        <div *ngFor="let buonoCantina of vino.buoni">
          <h6 class="lis-font-weight-500 mb-2 mt-3 vino-comprato">
            <span
              class="material-symbols-outlined mr-2 puntatore elimina-vino"
              (click)="
                rimuoviDalCarrelloBuoniCantina(
                  buonoCantina.idcarrello_buoni_cantina
                )
              "
              [matTooltip]="'carrello__item.elimina' | translate"
              matTooltipPosition="left"
            >
              highlight_off
            </span>
            + {{ buonoCantina.titolo }} ({{
              "base.voucher_esperienza" | translate
            }}) <br />
            {{ "base.scadenza" | translate }}:
            {{ getDataScadenzaBuono(buonoCantina) }}
          </h6>
          <div>
            <small *ngIf="buonoCantina.totale > 0">
              € {{ buonoCantina.totale }}
            </small>
            <small *ngIf="buonoCantina.totale == 0">
              {{ "gite_extra.incluso" | translate | titlecase }}
            </small>
          </div>
        </div>

        <hr />
      </div>
    </div>

    <div class="col-12 col-md-6 d-flex align-items-end">
      <div class="d-flex flex-column align-items-start">
        <small
          *ngIf="
            riga.isSpedizioneGratis === '1' && riga.costoSpedizioneCliente > 0
          "
        >
          {{
            "carrello__item.spedizionecarrello"
              | translate : { value: riga.spedizioneGratis }
          }}
        </small>
        <!-- <small
          *ngIf="
            riga.sconto == 0 &&
            !riga.scontoValido &&
            !riga.scontoScaduto &&
            riga.attivoScontoPerc
          "
        >
          <div
            [innerHTML]="
              'carrello__item.scontoperc'
                | translate
                  : {
                      mancanti: getMinimoScontoVini(riga) | number : '1.2-2',
                      sconto: chooseScontoVini(riga) | number : '1.2-2'
                    }
            "
          ></div>
        </small>
        <small
          *ngIf="
            riga.sconto == 0 &&
            !riga.scontoValido &&
            !riga.scontoScaduto &&
            !riga.attivoScontoPerc
          "
        >
          <div
            [innerHTML]="
              'carrello__item.scontoeuro'
                | translate
                  : {
                      mancanti: getMinimoScontoVini(riga) | number : '1.2-2',
                      sconto: chooseScontoVini(riga) | number : '1.2-2'
                    }
            "
          ></div>
        </small> -->
      </div>
    </div>
    <div
      class="col-12 col-md-6 d-flex justify-content-end align-items-end mobile-margin"
    >
      <div class="d-flex flex-column align-items-end">
        <small class="line-15">
          <span>
            {{ "base.totale_vino" | translate }}
          </span>
          <span class="price-wine line">
            € {{ riga.totaleVino | number : "1.2-2" }}
          </span>
        </small>

        <small class="line-15 scontoVini" *ngIf="riga.sconto != 0">
          <span> {{ "base.sconto" | translate }}&nbsp; </span>
          <span class="price-wine line">
            €&nbsp;{{ riga.sconto | number : "1.2-2" }}
          </span>
        </small>

        <ng-container
          *ngIf="riga.sconto_codici && riga.sconto_codici.length > 0"
        >
          <small
            class="line-15 scontoVini"
            *ngFor="let codice of riga.sconto_codici"
          >
            <span
              class="material-symbols-outlined"
              (click)="rimuoviCodiceScontoVino(codice)"
            >
              highlight_off
            </span>
            <span *ngIf="codice.tipo_unita_codice === '0'">
              {{
                "carrello_sconto.small_sconto"
                  | translate
                    : {
                        codice: codice.codice,
                        valore: codice.valore * -1 | number : "1.2-2"
                      }
              }}
            </span>
            <span *ngIf="codice.tipo_unita_codice === '1'">
              {{
                "carrello_sconto.small_sconto_perc"
                  | translate
                    : {
                        codice: codice.codice,
                        valore: codice.valore | number : "1.2-2"
                      }
              }}
            </span>
          </small>
        </ng-container>

        <small class="line-15" *ngIf="viniHaveBuoni(riga)">
          <span>
            {{ "base.totale_voucher" | translate }}
          </span>
          <span class="price-wine line">
            <span *ngIf="getTotaleBuoniVini(riga) > 0">
              € {{ getTotaleBuoniVini(riga) | number : "1.2-2" }}
            </span>
            <span *ngIf="getTotaleBuoniVini(riga) == 0">
              {{ "gite_extra.incluso" | translate | titlecase }}
            </span>
          </span>
        </small>

        <small class="line-15">
          <span>
            {{ "base.totale_spedizione" | translate }}
          </span>
          <span class="price-wine line">
            € {{ riga.costoSpedizioneCliente | number : "1.2-2" }}
          </span>
        </small>

        <div>
          <span>
            {{ "step1.totale" | translate }}
          </span>
          <span
            class="price-wine lis-font-weight-500 lis-dark lis-font-weight-600"
          >
            € {{ getTotaleVini(riga) | number : "1.2-2" }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngFor="let buonoCantina of buoniCantina; let last = last" class="riga">
  <div class="row lis-relative flex-md-row flex-column">
    <a
      (click)="
        rimuoviDalCarrelloBuoniCantina(buonoCantina.idcarrello_buoni_cantina)
      "
      class="puntatore d-flex text-right cancella"
      *ngIf="buonoCantina.omaggioCantina !== '1'"
    >
      <span
        class="material-symbols-outlined"
        [matTooltip]="'carrello__item.elimina' | translate"
        matTooltipPosition="left"
      >
        highlight_off
      </span>
    </a>

    <div *ngIf="buonoCantina.omaggioCantina !== '1'">
      <h6 class="lis-font-weight-500 mb-2 mt-3 vino-comprato">
        {{ buonoCantina.titolo }}
        ({{ "base.voucher_esperienza" | translate }}) <br />
        {{ "base.scadenza" | translate }}:
        {{ getDataScadenzaBuono(buonoCantina) }}
      </h6>
    </div>

    <div class="col-12 col-md-12">
      <div *ngIf="buonoCantina.pacchetti && buonoCantina.pacchetti.length > 0">
        <div *ngFor="let pacchetto of buonoCantina.pacchetti; let last = last">
          <h6 class="lis-font-weight-500 mb-0 vino-comprato">
            ({{ pacchetto.qta }}x) WineBox
            {{ pacchetto.titolo }}
          </h6>
          <span class="opzione" *ngFor="let opzione of pacchetto.opzioni"
            ><br />+ {{ opzione.descrizione }}
          </span>
          <p
            class="mb-0"
            *ngIf="pacchetto.promo != '' && pacchetto.promo != null"
          >
            <small class="lis-font-weight-600">
              {{ "base.promo" | translate }}
            </small>
            <span class="promo ml-2">{{ pacchetto.promo }}</span>
          </p>
        </div>
      </div>
    </div>

    <div
      class="col-12 col-md-12 d-flex align-items-end justify-content-end flex-wrap"
    >
      <hr class="w-100 mt-3" *ngIf="buonoCantina.omaggioCantina !== '1'" />
      <div class="d-flex align-items-end justify-content-end w-100">
        <div
          class="text-right omaggio"
          *ngIf="buonoCantina.omaggioCantina === '1'"
        >
          {{ "base.voucher_omaggio" | translate | uppercase }}
          <span class="material-symbols-outlined"> card_giftcard </span>
        </div>
        <div class="text-right" *ngIf="buonoCantina.omaggioCantina !== '1'">
          {{ "step1.totale" | translate }}
          <span class="lis-font-weight-500 lis-dark lis-font-weight-600"
            >€
            {{ getTotaleBuonoCantina(buonoCantina) | number : "1.2-2" }}</span
          >
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngFor="let riga of carrelloPacchetti; let last = last" class="riga">
  <div *ngFor="let pacchetto of riga.pacchetti; let last = last">
    <div class="row lis-relative flex-md-row flex-column">
      <a
        (click)="rimuoviDalCarrelloPacchetti(riga.idcarrello_pacchetti)"
        class="puntatore d-flex text-right cancella"
      >
        <span
          class="material-symbols-outlined"
          [matTooltip]="'carrello__item.elimina' | translate"
          matTooltipPosition="left"
        >
          highlight_off
        </span>
      </a>
      <div class="col-12 col-md-8">
        <h6 class="lis-font-weight-500 mb-2 item-comprato">
          ({{ pacchetto.qta }}x) WineBox
          {{ pacchetto.titolo }}
        </h6>
        <div *ngIf="pacchetto.opzioni && pacchetto.opzioni.length > 0">
          <div class="opzione" *ngFor="let opzione of pacchetto.opzioni">
            <br />+ {{ opzione.descrizione }}
          </div>
        </div>
        <p
          class="mb-0"
          *ngIf="pacchetto.promo != '' && pacchetto.promo != null"
        >
          <small class="lis-font-weight-600">
            {{ "base.promo" | translate }}
          </small>
          <span class="promo ml-2">{{ pacchetto.promo }}</span>
        </p>
      </div>
      <div class="col-12 col-md-4 d-flex justify-content-end align-items-end">
        <div>
          {{ "step1.totale" | translate }}
          <span class="lis-font-weight-500 lis-dark lis-font-weight-600"
            >€ {{ getTotalePacchetti(riga) | number : "1.2-2" }}</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
